import React, { useState } from "react";
import Exclamation from "../../../assets/icons/Exclamation";
import {
  Container,
  Header,
  Footer,
  Label,
  Reminder,
  ReText,
  DivIcon,
  Content,
  ContentHeader,
  ContentBody,
  ContentFooter,
} from "./styles";
import Button from "../Button";
import Modal from "../Modal";
import Close from "../../../assets/icons/Close";
import { FaFilePdf } from "react-icons/fa";
import { usePromiseTracker } from "react-promise-tracker";
import { Document, PDFDownloadLink } from "@react-pdf/renderer";
import PDFComponent from "../../PDF/flow/PDFComponent";
import { useRef } from "react";

const PDFModal = ({
  name,
  title = "",
  description = "",
  data: relatory,
  isOpen,
  onClose,
  selector,
  className,
  onConfirm,
}) => {
  const blob = useRef(null);

  const { promiseInProgress: PDFStatus } = usePromiseTracker({
    area: "pdf-data",
  });

  if (!name) {
    return;
  }

  const exportOptions = {
    format: ".pdf",
    link: (
      <PDFDownloadLink
        document={<PDFDocument relatory={relatory} />}
        fileName={`${name}.pdf`}
      >
        {(e) => {
          blob.current = e.blob;

          return !e.loading ? (
            <span style={{ width: "100%", display: "block" }}>{name}.pdf</span>
          ) : (
            <span> Gerando PDF, aguarde...</span>
          );
        }}
      </PDFDownloadLink>
    ),
  };

  let opcoes = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  };

  const data = {
    name: `${name}.pdf`,

    created_at: new Date().toLocaleDateString("pt-br", opcoes),
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      selector={selector}
      className={className}
    >
      <Container>
        <Header>
          <Label>Gerar PDF - {title}</Label>
          <Reminder style={{ marginBottom: "0.5rem" }}>
            <Exclamation style={{ height: "1.3125rem", width: "1.3125rem" }} />
            {description !== "" && <ReText>{description}</ReText>}
          </Reminder>
        </Header>

        <Content>
          <ContentHeader>
            <span>{data.name}</span>
            <span>{data.created_at}</span>
          </ContentHeader>
          <ContentBody>
            <FaFilePdf size={22} />
            <span style={{ marginLeft: "0.5rem" }}>
              {relatory ? exportOptions.link : name}
            </span>
          </ContentBody>
          <ContentFooter>
            {/* <span>Tamanho: {data.size}</span> */}
          </ContentFooter>
        </Content>
        <Footer>
          <Button
            disabled={PDFStatus}
            onClick={PDFStatus ? null : onConfirm}
            style={{ margin: "0 auto" }}
            content="Gerar novo PDF"
            width={"11.3125rem"}
            height={"2.625rem"}
          />
        </Footer>
        <DivIcon>
          <Close onClick={onClose} />
        </DivIcon>
      </Container>
    </Modal>
  );
};

const PDFDocument = ({ relatory }) => {
  return (
    <Document>
      <PDFComponent relatory={relatory} />
    </Document>
  );
};
export default PDFModal;
